import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { TimeBillingWorksheetStateClass } from './interfaces/TimeBillingWorksheetStateClass'

const initialState: TimeBillingWorksheetStateClass = {
    isLoading:true,
    status: 'idle',
    timeBillingWorksheetList: [],
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    start: 0,
    search: "",
    recordsFiltered: 0,
    isAllUnChecked: true,
    optionClientNameValue: "0",
    optionClientNameText: "All",
    optionEmployeeNameValue: "0",
    optionEmployeeNameText: "All",
    optionProjectValue: "0",
    optionProjectText: "All",
    optionTaskNameValue: "0",
    optionTaskNameText: "All",
    optionBilledValue: "-1",
    optionBilledText: "Both",
    columnIndex:0,
    direction:"asc",
    startDate: (() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 2);
        return newDate.toISOString();
    })(),
    endDate: new Date().toISOString(),
    isChecked: false,
    checkedItems: [],
    sortOrder: 'asc',
    sortColumn: '1'
}
interface IThunkApi {
    state: {
        timeBillingWorksheet: TimeBillingWorksheetStateClass;
    },
}
export const getTimeBilingWorksheetForDatatableAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Invoice/V2/GetTimeEntryBillingDatatable',
        async (arg, thunkApi) => {
            const { currentPage, pageSize, start, search, SearchParamsValues } = arg;
            const trimmedSearchParamsValues = SearchParamsValues.trim();
            const trimmedSearch = search.trim();
            const { sortOrder, sortColumn } = thunkApi.getState().timeBillingWorksheet;
            const encodedData = {
                currentPage:currentPage,
                pageSize:pageSize,
                start:start,
                orderDir:sortOrder,
                order:sortColumn,
                SearchParamsValues:trimmedSearchParamsValues,
                search: trimmedSearch
              };
            const response = await fetchAPI(
                'api/V2/Invoice/GetTimeEntryBillingDatatable/'+SearchParamsValues,
                'POST',
                encodedData,
                true,
                '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab'
            );

            const json = await response.json();
            return json;
        }
    )


    export const UpdateTimeBillingWorksheetAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/SubmitExpenseSheet',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Invoice/UpdateTimeBillingWorksheet', 'Post', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
  

export const timeBillingSlice = createSlice({
    name: 'timeBillingWorksheet',
    initialState,
    reducers: {        
        resetSelectedRecordObjectInState: (state) => {
            state.timeBillingWorksheetList = [];
        }, 
        Edit: (state, action) => {
            state.selectedRecord = action.payload;
        },
        setOptionClientNameValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionClientNameValue = value;
            state.optionClientNameText = label;
        },
        setOptionEmployeeNameValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionEmployeeNameValue = value;
            state.optionEmployeeNameText = label;
        },
        setOptionProjectValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionProjectValue = value;
            state.optionProjectText = label;
        },
        setOptionTaskValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionTaskNameValue = value;
            state.optionTaskNameText = label;
        },
        setOptionBilledValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionBilledValue = value;
            state.optionBilledText = label;
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
       
        setSearchValue: (state, action) => {
            state.search = action.payload;
            state.currentPage = 1;
        },
        setPageSizeValue: (state, action) => {
            state.pageSize = action.payload;
            state.currentPage = 1;
        },
        setSortConfig: (state, action) => {
            const {columnIndex,direction} = action.payload;
            let ndirection = 'asc';
            if (state.columnIndex === columnIndex && state.direction === 'asc') {
                ndirection = 'desc';
            }
            state.direction = ndirection;
            state.columnIndex = columnIndex;           
         },
        checkedBilledState: (state, action) => {
            const currentindex = state.timeBillingWorksheetList.findIndex((item) => item.AccountEmployeeTimeEntryId == action.payload);
            const newArray = [...state.timeBillingWorksheetList];
            newArray[currentindex] = { ...newArray[currentindex], Billed: true };
            state.timeBillingWorksheetList = newArray;
        },
        unCheckedBilledState: (state, action) => {
            const currentindex = state.timeBillingWorksheetList.findIndex((item) => item.AccountEmployeeTimeEntryId == action.payload);
            const newArray = [...state.timeBillingWorksheetList];
            newArray[currentindex] = { ...newArray[currentindex], Billed: false };
            state.timeBillingWorksheetList = newArray;
        },
        resetCheckedState: (state) => {
            state.timeBillingWorksheetList = state.timeBillingWorksheetList.map(item => ({
                ...item,
                Billed: false
            }));
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.start = action.payload.start;
            state.pageSize = action.payload.pageSize;
            state.currentPage = action.payload.currentPage;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTimeBilingWorksheetForDatatableAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getTimeBilingWorksheetForDatatableAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                if (payload.data !== undefined) {
                    state.timeBillingWorksheetList = JSON.parse(payload.data);
                    state.isReload = false;
                    state.selectedRecord = {};
                    state.search = payload.search;
                    state.currentPage = payload.currentPage;
                    state.start = payload.start;
                    state.totalItems = payload.recordsTotal;                   
                    state.recordsFiltered = payload.recordsFiltered;                  
                }
            })
            .addCase(getTimeBilingWorksheetForDatatableAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })  


            .addCase(UpdateTimeBillingWorksheetAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; 
            })
            .addCase(UpdateTimeBillingWorksheetAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false; 
            })
            .addCase(UpdateTimeBillingWorksheetAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; 
            })
    }
})

export const {
     Edit,
    setOptionBilledValue, setOptionClientNameValue, setOptionEmployeeNameValue
    , setOptionProjectValue, setOptionTaskValue, setDateRangeValue,
    setSearchValue, setPageSizeValue,setSortConfig, resetSelectedRecordObjectInState,checkedBilledState,unCheckedBilledState, updateSorting
} = timeBillingSlice.actions
export const TimeBillingWorksheetState = (state: RootState) => state.timeBillingWorksheet
export default timeBillingSlice.reducer